(function(){

  var loadScript = function(url, callback){ 
    var script = document.createElement("script");
    script.type = "text/javascript";
    //internet explorer
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    }
    //other browsers
    else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    //append to the head tag the script
    document.getElementsByTagName("head")[0].appendChild(script);
    
  };

  //code that I want to execute
  var myCode = function($){
    function onlyUnique(value, index, self) {
  		return self.indexOf(value) === index;
	}
    function capitalize(string) {
    	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
	}
    window.addEventListener("load", function(){
        jQuery(".chk_tags_dynamic_filter").change(function() {
           var array = [];   
           if(!this.checked) jQuery("[value='"+this.value+"']").prop('checked', false);
           jQuery("input:checkbox[name=dynamic_tag_filters]:checked").each(function() {
              array.push(jQuery(this).val());
           })
           //console.log(this.value);
           array = array.filter(onlyUnique);
           console.log(array);
           var pathname = window.location.pathname;
           var tags_as_url = array.join('+').replace(/\s/g, "-");
           pathname = pathname.replace(/^(\/collections\/[^\/]+).*$/, "$1/" + tags_as_url);
           var o_url=window.location.href;     
           var c_url = o_url.split("/collections/");
           setTimeout(function(){  window.location.href = c_url[0] + pathname; }, 500);
          
       });
 //style knapp ved klikk 
      jQuery('.variant-input').on('click', function(e) {
        jQuery(this).find('label').get(0).click();
      });

 //legg til tooltip på pyramider med 35
       if (window.location.href.indexOf("pyramide") > -1) {
          jQuery( ".variant-input" ).each(function(index) {
            if ( this.innerHTML.indexOf("Spar") > -1) {
              jQuery(this).prepend("<div class='baerekraft'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-leaf' style='width:15px;height:15px' viewBox='0 0 64 64'><defs><style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class='cls-' d='M51 12L13 50M35 13v15h16'></path><path class='cls-1' d='M52 11c6 24-16.72 47.29-33 32C7 22 29 10 52 11z'></path></svg>Smart miljøvalg</div>");  
          
            }
            
            else {}         
          });  
      }
          //legg til fri frakt på 2 matcha
      else if (window.location.href.indexOf("matcha-okologisk-gronn-te") > -1) {
          jQuery( ".variant-input" ).each(function(index) {
            if ( this.innerHTML.indexOf("2 x") > -1) {
              jQuery(this).prepend("<div class='baerekraft' style='line-height:2em;'>Gratis frakt</div>");  
          
            }
            
            else {}         
          });  
      }
      else {} 
       
      
      if(typeof ctags != 'undefined'){
      	var tags = JSON.parse(ctags);
        for(var i=0;i<tags.length;i++){
          var tag_title = tags[i].split("_");
          if(tag_title.length > 1){
          	var tag_h_name = capitalize(tag_title[0]);
            jQuery(".collection-sidebar__group--"+tag_h_name).find("button").addClass("is-open");
            jQuery(".collection-sidebar__group--"+tag_h_name).find(".collapsible-content").addClass("is-open");
            jQuery(".collection-sidebar__group--"+tag_h_name).find(".collapsible-content").css("height","auto");
          }
        }
      }
  });
    
    
    
  };

  if (typeof jQuery === 'undefined'){
    loadScript('//code.jquery.com/jquery-1.12.4.min.js', function(){
      jQuery = jQuery.noConflict(true);
      if (typeof jQuery.slick === 'undefined'){
      	 myCode(jQuery);
      }
    });
  } else {
    myCode(jQuery);
  }

})();
